<template>
<div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header py-2 pe-2">
                <strong class="modal-title" id="erkModalLabel">DETTAGLI</strong>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="isLoading">

                </div>
                <div v-else>
                    <table class="table table-hover align-middle">
                        <tr>
                            <td>Svolgimento</td>
                            <td><div>{{response.row.date}}</div></td>
                        </tr>
                        <tr>
                            <td>Correttezza</td>
                            <td>
                                <div v-if="response.options.score">{{response.row.score * 100}} %</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Stimoli</td>
                            <td>
                                <div v-if="response.options.numero_stimoli">{{response.options.numero_stimoli}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Presentazione</td>
                            <td>
                                <div v-if="response.options.presentazione">{{response.options.presentazione}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Esposizione</td>
                            <td>
                                <div v-if="response.options.esposizione">{{response.options.esposizione}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Intervallo</td>
                            <td>
                                <div v-if="response.options.intervallo">{{response.options.intervallo}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Comparsa</td>
                            <td>
                                <div v-if="response.options.comparsa">{{response.options.comparsa}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Tipo stimolo</td>
                            <td>
                                <div v-if="response.options.tipologia_stimoli">{{response.options.tipologia_stimoli}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>Risposta</td>
                            <td>
                                <div v-if="response.options.risposta">{{response.options.risposta}}</div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'

export default{
    props: {
        userId: Number
    },
    data(){
        return {
            isLoading: true,
            response: {}
        }
    },
    mounted(){
    },
    methods: {
        opeDetails(sessionId){
            this.isLoading = true
            let url = "/structure/student/report/UserHistoryTachiAction-details?userId=" + this.userId
                        + "&IdStats=" + sessionId

            axios.get(url)
                .then((response) => {
                    this.isLoading = false

                    if (response.hasErrors){
                        return
                    }

                    this.response = response.data.result
                    this.toggle()
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        toggle(){
            let myModal = new window.bootstrap.Modal(this.$refs.modal)
            myModal.toggle()
        }
    }
}
</script>
<style scoped>
td div{
    line-height: 2;
}
</style>